export default __webpack_public_path__ + "search-overview-header-1200-33b6bbde24ae27620b0f79d5b6191b73.webp";